import i from "./highrise949.mjs";
function n(o) {
  const {
    textColor1: t,
    dividerColor: r,
    fontWeightStrong: e
  } = o;
  return {
    textColor: t,
    color: r,
    fontWeight: e
  };
}
const f = {
  common: i,
  self: n
};
export {
  f as default,
  n as self
};
